import { School, Search, Work } from '@mui/icons-material'
import { type FilterTab } from 'recruiter/components/FiltersDrawer'
import { getCandidateFilterTabMeta } from 'recruiter/components/CandidateTableToolbar/candidateFilterTabConfig'
import { ExperienceFilterSection } from 'recruiter/components/CandidateTableToolbar/ExperienceFilterSection'
import { SearchesFilterSection } from 'recruiter/components/CandidateTableToolbar/SearchesFilterSection'
import { EducationFilterSection } from 'recruiter/components/CandidateTableToolbar/EducationFilterSection'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'

const iconSx = { fontSize: '1.125rem' }

export function buildClientSearchesFilterTabs(
    filters: CandidateFilterState,
    updateFilters: (patch: Partial<CandidateFilterState>) => void
): FilterTab[] {
    const meta = getCandidateFilterTabMeta(filters)

    return [
        {
            icon: <Work sx={iconSx} />,
            label: 'Experience',
            content: (
                <ExperienceFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.experience.hasActive
                ? () => updateFilters(meta.experience.clearValues)
                : undefined,
        },
        {
            icon: <Search sx={iconSx} />,
            label: 'Searches',
            content: (
                <SearchesFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.searches.hasActive
                ? () => updateFilters(meta.searches.clearValues)
                : undefined,
        },
        {
            icon: <School sx={iconSx} />,
            label: 'Education',
            content: (
                <EducationFilterSection
                    filters={filters}
                    updateFilters={updateFilters}
                />
            ),
            onClear: meta.education.hasActive
                ? () => updateFilters(meta.education.clearValues)
                : undefined,
        },
    ]
}
